const VALID_STRATEGIES = new Set(["efficient_cutting", "preserve_offcuts", "strips"]);

export const DEFAULT_WERKPLAN = {
  globalStrategy: "efficient_cutting",
  minOffcutLength: 500,
  minOffcutWidth: 300,
  showOffcuts: false,
  showCutSequence: true,
  stripsNoCrosscut: true,
  emphasizeExactSizes: true,
  includeNewSheets: true,
  includeRestSheets: true,
  orderOversizeEnabled: false,
  orderOversizeLength: 2,
  orderOversizeWidth: 2,
  generalNote: "Graag zagen volgens onderstaande zaaglijst. De zaagmaten zijn leidend.",
};

export const DEFAULT_EXPORT_ANNOTATIONS = {
  sheetStrategies: {},
  sheetNotes: {},
  rowOverrides: {},
};

export function normalizeWerkplan(raw) {
  const strategy = raw?.globalStrategy;
  const globalStrategy = VALID_STRATEGIES.has(strategy) ? strategy : DEFAULT_WERKPLAN.globalStrategy;

  return {
    ...DEFAULT_WERKPLAN,
    ...(raw || {}),
    globalStrategy,
    minOffcutLength: Number(raw?.minOffcutLength ?? DEFAULT_WERKPLAN.minOffcutLength),
    minOffcutWidth: Number(raw?.minOffcutWidth ?? DEFAULT_WERKPLAN.minOffcutWidth),
    showOffcuts: raw?.showOffcuts ?? DEFAULT_WERKPLAN.showOffcuts,
    showCutSequence: raw?.showCutSequence ?? DEFAULT_WERKPLAN.showCutSequence,
    stripsNoCrosscut: globalStrategy === "strips"
      ? true
      : raw?.stripsNoCrosscut ?? DEFAULT_WERKPLAN.stripsNoCrosscut,
    emphasizeExactSizes: raw?.emphasizeExactSizes ?? DEFAULT_WERKPLAN.emphasizeExactSizes,
    includeNewSheets: raw?.includeNewSheets ?? DEFAULT_WERKPLAN.includeNewSheets,
    includeRestSheets: raw?.includeRestSheets ?? DEFAULT_WERKPLAN.includeRestSheets,
    orderOversizeEnabled: raw?.orderOversizeEnabled ?? DEFAULT_WERKPLAN.orderOversizeEnabled,
    orderOversizeLength: Math.max(0, Number(raw?.orderOversizeLength ?? DEFAULT_WERKPLAN.orderOversizeLength)),
    orderOversizeWidth: Math.max(0, Number(raw?.orderOversizeWidth ?? DEFAULT_WERKPLAN.orderOversizeWidth)),
    generalNote: raw?.generalNote ?? DEFAULT_WERKPLAN.generalNote,
  };
}

export function normalizeExportAnnotations(raw) {
  return {
    sheetStrategies: { ...(raw?.sheetStrategies || {}) },
    sheetNotes: { ...(raw?.sheetNotes || {}) },
    rowOverrides: { ...(raw?.rowOverrides || {}) },
  };
}
